import React from 'react';
import { CheckIcon } from 'lucide-react';
import { systemBullets } from '../data/content';
export function SystemOverview() {
  return <section className="bg-navy px-3 py-4 text-white sm:px-6" data-id="element-139" data-mp="18ur5jn4cc488">
      <div className="mx-auto max-w-2xl text-center" data-id="element-140" data-mp="1mmxbyhhoywuh">
        <h2 className="text-[1.1rem] font-extrabold uppercase leading-tight sm:text-[1.7rem]" data-id="element-141" data-mp="1morvbrdbegwg">
          The complete 6-in-1 ultrasound study system
        </h2>
        <p className="mt-1 text-[0.9rem] font-extrabold uppercase tracking-wide text-gold sm:text-[1.1rem]" data-id="element-142" data-mp="tyrq1rewj1t2">
          🩻 ULTRASOUND VISUAL ATLAS™
        </p>
        <p className="mt-1 text-[0.68rem] font-bold uppercase tracking-[0.14em] text-cyan sm:text-[0.78rem]" data-id="element-143" data-mp="13vwexz04tbdk">
          Orient • Scan • Understand • Compare • Identify • Recognize
        </p>
        <ul className="mt-2 grid gap-1 text-left sm:grid-cols-2" data-id="element-144" data-mp="2fbcp0yh9j536">
          {systemBullets.map(b => <li key={b} className="flex items-start gap-1.5 rounded border border-white/15 bg-white/5 px-2 py-1.5" data-id="element-145" data-mp="2aci7s0yy1ol6">
              <CheckIcon className="mt-[2px] h-3 w-3 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-146" data-mp="2364d91h2vqgb" />
              <span className="text-[0.75rem] leading-tight text-white/90 sm:text-[0.86rem]" data-id="element-147" data-mp="2d5lgzdcrru9n">
                {b}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}